import { globalProps } from "neetocommons/initializers";
import { Typography } from "neetoui";
import PropTypes from "prop-types";
import { Trans as ReactTrans } from "react-i18next";

const Trans = ({
  i18nKey,
  additionalValues = {},
  additionalComponents = {},
}) => (
  <ReactTrans
    {...{ i18nKey }}
    components={{
      Code: (
        <Typography
          className="neeto-ui-rounded-md neeto-ui-bg-gray-100 p-1"
          component="code"
          style="body3"
        />
      ),
      Semibold: (
        <Typography
          className="n inline-block text-sm font-medium"
          component="p"
        />
      ),
      ...additionalComponents,
    }}
    values={{
      productSuffix: globalProps.appName,
      ...additionalValues,
    }}
  />
);

Trans.propTypes = {
  i18nKey: PropTypes.string.isRequired,
  additionalValues: PropTypes.object,
  additionalComponents: PropTypes.objectOf(PropTypes.element),
};

export default Trans;
